import { useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';

export const Upload = ({
	setAnswer,
	answer,
	file,
	setFile,
	maxFileSize = 5,
}) => {
	const [fileToLargeErr, setFileToLargeErr] = useState(false);

	const handleValidFileUpload = newFile => {
		setFileToLargeErr(false);
		setFile(newFile);
	};

	const handleInvalidFileUpload = () => {
		setFileToLargeErr(true);
		setFile(null);
	};

	const calcFileSize = newFile =>
		parseFloat(newFile.size / (1024 * 1024)).toFixed(2);

	return (
		<div className=" mt-5">
			<Row className="mb-4 d-flex">
				<Col xs="12" md="6" className="mt-2">
					<Card
						onClick={() => setAnswer(true)}
						style={answer ? { border: 'solid #0074d9 2px' } : {}}>
						<Card.Body>
							<Card.Title>Yes</Card.Title>
						</Card.Body>
					</Card>
				</Col>
				<Col xs="12" md="6" className="mt-2">
					<Card
						onClick={() => setAnswer(false)}
						style={answer === false ? { border: 'solid #0074d9 2px' } : {}}>
						<Card.Body>
							<Card.Title>No</Card.Title>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			{answer && (
				<div className="custom-file mt-5 input-group">
					<label className="custom-file-label" htmlFor="customFile">
						{file?.name ? file.name : 'Choose File'}
					</label>
					<input
						type="file"
						className="custom-file-input"
						id="customFile"
						onChange={e => {
							calcFileSize(e.target.files?.[0]) > maxFileSize
								? handleInvalidFileUpload()
								: handleValidFileUpload(e.target.files[0]);
						}}
						autoFocus
					/>
					{fileToLargeErr === true && (
						<div className="form-text text-danger">File size limit: 5MB</div>
					)}
				</div>
			)}
		</div>
	);
};
